import React from 'react'
import { browserHistory } from 'react-router';


class UserLoggedRedirect extends React.Component {

    componentWillMount() {
        if(this.props.user.role == "provider")
           browserHistory.push('/prestataire/fiche')
         else
           browserHistory.push('/manager/dashboard')  
    }

    render() {
    	return null
    }
}


export default UserLoggedRedirect



// WEBPACK FOOTER //
// ./src/user/components/UserLoggedRedirect.js